/** LOT 47 — Dates timezone-agnostiques (Guadeloupe UTC-4).
 *  `new Date("2026-11-30")` est interprété en UTC minuit → recule d'un jour en
 *  local (UTC-4). On manipule donc les dates en chaînes absolues YYYY-MM-DD et
 *  on construit les Date en heure LOCALE (jamais UTC). */

export function parseLocalDate(s) {
    if (!s) return null;
    const m = String(s).slice(0, 10).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    const d = new Date(s);
    return isNaN(d) ? null : d;
}

export function toIsoLocal(d) {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function formatFrDate(s, opts = { day: "2-digit", month: "2-digit", year: "2-digit" }) {
    const d = parseLocalDate(s);
    return d ? d.toLocaleDateString("fr-FR", opts) : null;
}

/** LOT 85 — Ajoute n jours CALENDAIRES à une date ISO YYYY-MM-DD (délai de paiement BFR). */
export function addDays(iso, n) {
    const d = parseLocalDate(iso);
    if (!d) return null;
    d.setDate(d.getDate() + (Number(n) || 0));
    return toIsoLocal(d);
}

/** LOT 67 — Ajoute n jours OUVRÉS (lun–ven) à une date ISO YYYY-MM-DD. */
export function addBusinessDays(iso, n) {
    const d = parseLocalDate(iso);
    if (!d) return null;
    let added = 0;
    while (added < n) {
        d.setDate(d.getDate() + 1);
        const wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
    }
    return toIsoLocal(d);
}
